import { LeftSideMenu } from "../../components/leftSideMenu/LeftSideMenu";
import { JaaSMeeting, JitsiMeeting } from "@jitsi/react-sdk";
import { TabbedContent } from "../../components/tabs/TabbedContent";
import DataTable from "../../components/dataTables/DataTable";
import { useDoctorAppointments } from "../../hooks";
import { buildColDefs } from "../../components/dataTables/buildColDefs";
import { UserAppointmentDoctor } from "../../data-parsing/userAppointment/UserAppointment";
import API from "../../api/api"

export default function Consultation() {
  const { appointments,refresh } = useDoctorAppointments(
    sessionStorage.getItem("userid")
  );
  const userData = JSON.parse(sessionStorage.getItem("user"));
  let appointmentColDefs = buildColDefs(UserAppointmentDoctor);

  /*   const callUser = (userId) => {
      console.log("CALLBACK PARA VIDEOLLAMADA", userId);
    
        return userId;
  
  };
 */
  return (
    <LeftSideMenu active="consultation">
      <div id="wrapper">
        <div className="container">
          <div className="row">
            <div className="col-xs-12">
              <div className="card-box card-tabs m-t-20">
                <h4 className="header-title m-r-10 m-l-10 pull-right">
                  CONSULTAS
                </h4>
                <div id="tabViewDoctors" className="m-t-40">
                   <DataTable
                    colDefs={appointmentColDefs}
                    data={
                      // appointments
                      //FIXME - THIS IS A TEMPORAL WORKAROUND DUE TO THE BACKENDs
                      appointments?.filter((v) => {
                        console.log("appointments", appointments)
                        return v["user_id"] !== "67cf00eb52c911022f5a9830"
                      })
                    }
                    deleteElement={(id,ri) => {
                      alert("@alreylz - This seems to never have been implemented. Here you should provide the code to remove the element")

                      console.log(`DELETE ELEMENT`, id)
                      API.instance()
                        .deleteUserAppointment(id)
                        .then((response) => {
                          console.log("response delete appointment", response);
                          // let appointments = [...data];
                          // appointments = appointments.filter((e) => {
                          //   return e._id !== id;
                          // });

                          //FIXME - This is another horrendous thing of this codebase, since it is not using react for the tables themselves and removing causes problems
                          // refresh() - This would be the proper way to do things, 
                          //instead i am doing this

                          window.location.reload()
                        });

                      

                    }}
                    dataId={"DoctorAppointments"}
                    resizable={true}
                    allowHiddenColumns={false}
                    scrollX={false} /*editElement={updateUser}*/
                    className="table table-bordered panel-group" /*deleteElement={deleteUser}*/
                  /*                     videocallCallback={callUser}
                */
                  />
                </div>
                {/*                  <div id="tabCall">
                    <JaaSMeeting
                      appId={"YOUR_APP_ID"}
                      roomName="PleaseUseAGoodRoomName"
                      useStaging={false}
                      getIFrameRef={(node) => (node.style.height = "800px")}
                      configOverwrite={{
                        hiddenPremeetingButtons: ["invite", "settings"],
                        prejoinPageEnabled: false,
                      }}
                      userInfo={{
                        displayName: userData?.name,
                        email: userData?.email,
                      }}
                      onApiReady={async (api) => {
                        console.log(api._url);
                      }}
                    />
                  </div> */}
              </div>
            </div>
          </div>
        </div>
      </div>
    </LeftSideMenu>
  );
}
